import { render, staticRenderFns } from "./PasoCuatroInvitaciones.vue?vue&type=template&id=ca6306cc"
import script from "./PasoCuatroInvitaciones.vue?vue&type=script&lang=js"
export * from "./PasoCuatroInvitaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports